/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';

import { Log } from '../logging';
import { IKeyManager } from './interfaces';

export class KeyManager implements IKeyManager {
    private static TAG: string = 'KeyManager';

    private static ABSOLUTE_MAX_KEY_IGNORE_TIME: number = 30000; // 30 seconds

    private static mKeyManager: KeyManager;

    private mIsKeyIgnoring: boolean;

    private mKeyIgnoringStartTime: number;

    private constructor() {
        this.mIsKeyIgnoring = false;
        this.mKeyIgnoringStartTime = 0;
    }

    public static getInstance(): KeyManager {
        if (!KeyManager.mKeyManager) {
            KeyManager.mKeyManager = new KeyManager();
        }
        return KeyManager.mKeyManager;
    }

    public isKeyIgnoring(): boolean {
        const now = Date.now();
        const transitionTime =
            this.mKeyIgnoringStartTime > 0 ? now - this.mKeyIgnoringStartTime : 0;
        if (transitionTime > KeyManager.ABSOLUTE_MAX_KEY_IGNORE_TIME) {
            Log.i(
                KeyManager.TAG,
                'Exceeded absolute maximum key ignoring time, now stop key ignoring',
            );
            Diagnostics.info(
                KeyManager.TAG,
                'Exceeded absolute maximum key ignoring time, now stop key ignoring',
            );
            this.stopKeyIgnoring();
        }
        return this.mIsKeyIgnoring;
    }

    public startKeyIgnoring(): void {
        Log.i(KeyManager.TAG, 'startKeyIgnoring');
        Diagnostics.info(KeyManager.TAG, 'startKeyIgnoring');
        this.mKeyIgnoringStartTime = Date.now();
        this.mIsKeyIgnoring = true;
    }

    public stopKeyIgnoring(): void {
        Log.i(KeyManager.TAG, 'stopKeyIgnoring');
        Diagnostics.info(KeyManager.TAG, 'stopKeyIgnoring');
        this.mIsKeyIgnoring = false;
        this.mKeyIgnoringStartTime = 0;
    }
}
